import type { OutputRelationshipT, RelationshipLabelDefinitionT, RelationshipStoreWithLabelDataT } from '../../../modernization-common/relationships';
import { getCompositeRelationshipLabelName } from '../../../modernization-common/relationships/utils';
import type { AnnotationWithFrameRangesT } from '../atoms/relationship-atoms';
export const mapToRelationshipStore = (relationships: OutputRelationshipT[] = [], relationshipLabels: RelationshipLabelDefinitionT[] = [], allAnnotations: {
  [key: string]: AnnotationWithFrameRangesT;
} = {}): RelationshipStoreWithLabelDataT => {
  const labelsMap = Object.fromEntries(relationshipLabels.map(l => [l.name, l]));
  const store: RelationshipStoreWithLabelDataT = {};
  for (const relationship of relationships) {
    const sourceAnnotation = allAnnotations[relationship.sourceAnnotationId];
    const targetAnnotation = allAnnotations[relationship.targetAnnotationId];
    if (!sourceAnnotation || !targetAnnotation) continue;
    const name = getCompositeRelationshipLabelName(relationship.labelName, sourceAnnotation.annotationLabel.title, targetAnnotation.annotationLabel.title);
    const relationshipLabel = labelsMap[name];
    if (!relationshipLabel) continue;
    store[relationship.id] = {
      ...relationship,
      relationshipLabel
    };
  }
  return store;
};